<div class="vw-100 vh-100 position-fixed container-spinner" style="z-index: 999999;">
  <img src="assets/img/spinner.gif" />
</div>
